export default "__VITE_ASSET__kN$BIrlZ__"